import React from 'react';
import { t } from 'i18next';
import { ItemPhoto } from '@/types/item';
import { LockOutlined, DeleteForeverOutlined, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { buildItemPhotoUrl } from '@/utilities/image';
import { Modal } from '@/types/modal';
import styles from './Photos.module.scss';

export type OrderStatus = 'Init' | 'Editing' | 'Completed';
const View: React.FC<{
  setModal: (m: Modal | null) => void;
  itemId: number;
  photos: ItemPhoto[];
  orderStatus: OrderStatus;
  moveLeft: (index: number) => void;
  moveRight: (index: number) => void;
  updateStatus: (status: OrderStatus) => void;
}> = ({ setModal, itemId, photos, orderStatus, moveLeft, moveRight }) => {
  if (photos.length === 0) {
    return (
      <div className={styles.container}>
        <div className={styles.wrapper}>{t('common.no_photo')}</div>
      </div>
    );
  }

  // Photo size we use the recommended from server as below
  // "default" => ['format' => 'auto', 'width' => '214.0', 'height' => '214.0', 'fit' => 'contain', 'dpr' => 1],
  // "over" => ['format' => 'auto', 'width' => '446.0', 'height' => '446.0', 'fit' => 'contain', 'dpr' => 1],
  // "click" => ['format' => 'auto', 'width' => '1200.0', 'height' => '1200.0', 'fit' => 'contain', 'dpr' => 1],
  // "nami" => ['format' => 'auto', 'width' => '48.0', 'height' => '48.0', 'fit' => 'contain', 'dpr' => 1],
  // "mosaic" => ['format' => 'auto', 'width' => '200.0', 'height' => '200.0', 'fit' => 'pad', 'dpr' => 1],
  // "sla" => ['format' => 'auto', 'width' => '120.0', 'height' => '120.0', 'fit' => 'pad', 'dpr' => 1],

  const showBigPhoto = (index: number) =>
    setModal({ kind: 'ItemPhotos', photos: photoItems, index, onClose: () => setModal(null) });
  const photoItems = photos.map(({ photoName }) => buildItemPhotoUrl(photoName, 1200));
  return (
    <div
      data-cy={`photo-container`}
      className={styles.container}
    >
      <div className={styles.wrapper}>
        {photos.map(({ id, photoName }, index) => {
          return (
            <div
              key={id}
              className={styles.photoContainer}
              data-cy={`photo-item`}
            >
              <div
                className={styles.photo}
                style={{ backgroundImage: `url("${buildItemPhotoUrl(photoName, 446)}")` }}
                onClick={() => showBigPhoto(index)}
              />
              {index === 0 && (
                <div
                  className={styles.lockContainer}
                  onClick={() => showBigPhoto(index)}
                >
                  <div className={styles.lockBackground} />
                  <LockOutlined className={styles.lock} />
                </div>
              )}
              {orderStatus === 'Init' && index > 1 && (
                <div
                  className={styles.deleteContainer}
                  onClick={() => showBigPhoto(index)}
                >
                  <DeleteForeverOutlined
                    className={styles.deleteIcon}
                    onClick={(e) => {
                      e.stopPropagation();
                      setModal({ kind: 'ItemPhotoDelete', photo: photoName, itemId, onClose: () => setModal(null) });
                    }}
                  />
                </div>
              )}
              {orderStatus === 'Editing' && index > 0 && (
                <div className={styles.orderContainer}>
                  <KeyboardArrowLeft
                    className={styles.orderIcon}
                    onClick={() => moveLeft(index)}
                  />
                  <KeyboardArrowRight
                    className={styles.orderIcon}
                    onClick={() => moveRight(index)}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default View;
